import { render, staticRenderFns } from "./FilterSales.vue?vue&type=template&id=5fa20c02"
import script from "./FilterSales.vue?vue&type=script&lang=js"
export * from "./FilterSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports